// src/routes/termOfPaymentsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import TermOfPayments from '../pages/termOfPayments/TermOfPayments';
import CreateTermOfPayments from '../pages/termOfPayments/CreateTermOfPayments';
import EditTermOfPayments from '../pages/termOfPayments/EditTermOfPayments';
import ProtectedRoute from '../components/global/ProtectedRoute';

const termOfPaymentsRoutes = (
    <>
        {/* Term of Payments List */}
        <Route
            path="/term-of-payments"
            element={
                <ProtectedRoute requiredPermission="termOfPayments_list">
                    <TermOfPayments />
                </ProtectedRoute>
            }
        />

        {/* Term of Payments Archive */}
        <Route
            path="/term-of-payments/archive"
            element={
                <ProtectedRoute requiredPermission="termOfPayments_archive_list">
                    <TermOfPayments />
                </ProtectedRoute>
            }
        />

        {/* Create Term of Payment */}
        <Route
            path="/term-of-payments/create"
            element={
                <ProtectedRoute requiredPermission="termOfPayments_create">
                    <CreateTermOfPayments />
                </ProtectedRoute>
            }
        />

        {/* Edit Term of Payment */}
        <Route
            path="/term-of-payments/:id/edit"
            element={
                <ProtectedRoute requiredPermission="termOfPayments_edit">
                    <EditTermOfPayments />
                </ProtectedRoute>
            }
        />
    </>
);

export default termOfPaymentsRoutes;